import React, { useEffect, useState } from 'react';

/** "A new version is available" prompt; tapping Refresh activates it and reloads. */
export default function UpdateBanner() {
  const [worker, setWorker] = useState(null);
  useEffect(() => {
    const onUpdate = (e) => setWorker(e.detail && e.detail.worker);
    window.addEventListener('zp-sw-update', onUpdate);
    return () => window.removeEventListener('zp-sw-update', onUpdate);
  }, []);
  if (!worker) return null;
  return (
    <div role="status" className="fixed bottom-4 inset-x-4 z-50 mx-auto max-w-md rounded-lg shadow-lg bg-white border border-gray-200 px-4 py-3 flex items-center gap-3 text-sm">
      <span className="flex-1 text-gray-800">A new version of ZoomPay is available.</span>
      <button
        className="rounded px-3 py-1.5 font-medium text-white"
        style={{ backgroundColor: '#045D41' }}
        onClick={() => {
          window.__zpSwRefreshRequested = true;
          worker.postMessage({ type: 'SKIP_WAITING' });
        }}
      >
        Refresh
      </button>
    </div>
  );
}
